<template lang="pug">
b-container
  b-row.mb-2.d-flex.align-items-baseline
    b-col()
      b-input-group(size="md" )
        b-form-input(type="search", placeholder="Buscar administrador..." v-model="search_admin" debounce="1000")
        b-input-group-append
          b-input-group-text
            search-icon.icon-sm
    b-col(cols='auto')
      b-dropdown#parent_drop(right, variant='light')
        template.p-0.m-0(slot='button-content')
          filter-icon.icon-sm
        b-dropdown-header Tipo de caso
          v-select.mt-2(
            placeholder='Seleccionar tipo',
            :options='caseTypes',
            label='name',
            :clearable='false',
            style='min-width: 250px',
            v-model='filters.caseType'
            @input='setFilter("caseType", $event)')
  b-tabs(justified, nav-class="flex-nowrap scrollable-area overflow-hidden overflow-x pb-1", small)
    b-tab(title="Todos", @click="loadGroupAdmins()", v-if="$can('read', 'show-all-groups')")
    b-tab(v-for="group in groups", :key="group.value", :title="group.text", @click="loadGroupAdmins(group.value)")
  b-table.scrollable-area.mt-2(ref="adminsTable", :items="skAdminsParsed", :fields="fields", responsive, :busy="loading_admins", small, sticky-header, style="max-height:500px")
    template(v-slot:empty)
      p.text-help.mb-0.text-center.my-4 {{search_admin.length ? 'No hay coincidencias' : 'No hay agentes creados'}}
    template(v-slot:table-busy)
      .text-center
        b-spinner(variant="primary")
    template(v-slot:cell(first_name)="{ item }")
      b-form-row.align-items-center
        b-col(cols="auto")
          b-avatar.mr-3(size="40px", :src="item.image")
        b-col(cols="auto")
          p.mb-0 {{ item.first_name }} {{ item.last_name }}
          .text-secondary.text-sm {{item.email}}
    template(v-slot:cell(status)="{ item }")
      .text-center(:class="item.current_status.variant || 'text-secondary'") {{ item.current_status.title }}
    template(v-slot:cell(num_open_cases)="{ item }")
      .d-flex.justify-content-between

        div.text-success Abiertos:
        .ml-1 {{item.statusCases.open.count || 0}}
      .d-flex.justify-content-between
        div.text-primary Espera:
        .ml-1 {{item.statusCases.onHold.count || 0}}
    template(v-slot:cell(no_answer)="{ item }")
      b-col
        span.text-success {{"<"}} 3 minutos
        span.text-success.ml-1 {{ item.statusTime.lessThree || 0 }}
      b-col
        span.text-warning {{">"}} 3 minutos
        span.text-warning.ml-1 {{ item.statusTime.overThree || 0 }}
      b-col
        span.text-danger {{">"}} 15 minutos
        span.text-danger.ml-1 {{ item.statusTime.overFiveTen || 0 }}
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import { EventBus } from '../helpers/eventBus'
import { TimeChild, timeObserver } from '../helpers/timeObserver'
const groupController = createNamespacedHelpers('group')
const accountController = createNamespacedHelpers('account')
const adminController = createNamespacedHelpers('admin')
export default {
  name: 'CaseSummary',
  data: () => {
    return {
      filters: {
        caseType: {
          value: 'all',
          name: 'Todos'
        }
      },
      caseTypes: [
        {
          name: 'Inbound',
          value: 'false'
        },
        {
          name: 'Outbound',
          value: 'true'
        },
        {
          name: 'Todos',
          value: 'all'
        }
      ],
      loading_admins: false,
      currentGroup: null,
      skAdmins: [],
      fields: [
        { key: 'first_name', label: 'Nombre' },
        { key: 'num_open_cases', label: 'Casos' },
        { key: 'status', label: 'Estado' },
        { key: 'no_answer', label: 'Sin Responder' }
      ],
      search_admin: '',
      account: null,
      admins_status: [],
      admin_statuses: [
        {
          title: 'Disponible',
          variant: 'text-success',
          icon: 'check-circle-icon',
          value: 'available'
        },
        {
          title: 'Pausa administrativa',
          variant: 'text-primary',
          icon: 'clock-icon',
          value: 'backoffice'
        },
        {
          title: 'Descanso',
          variant: 'text-secondary',
          icon: 'coffee-icon',
          value: 'break'
        },
        {
          title: 'Desconectado',
          variant: 'text-secondary',
          icon: 'power-icon',
          value: 'offline'
        }
      ]
    }
  },
  inject: {
    caseSocket: {
      default: Object
    }
  },
  computed: {
    ...groupController.mapState({
      groups: (state) =>
        state.groups.map((g) => {
          return { text: g.name, value: g.group_id }
        })
    }),
    ...accountController.mapState({
      admins: (state) =>
        state.admins.map((admin) => ({
          ...admin,
          statusCases: { open: {}, onHold: {} },
          statusTime: {},
          timeObserver: null
        }))
    }),
    skAdminsParsed() {
      return this.skAdmins.map((admin) => {
        const adminsStatus = this.admins_status.find(
          (admin_) => admin_.admin_id === admin.admin_id
        )
        const status = this.admin_statuses.find(
          (status) => adminsStatus && status.value === adminsStatus.status
        )
        admin.current_status = status || {
          title: 'Desconectado',
          value: 'default'
        }
        return admin
      })
    }
  },
  watch: {
    admins(newAdmins, oldAdmins) {
      oldAdmins.forEach((admin) => {
        if (!admin.timeObserver) return
        admin.timeObserver.remove()
      })
      this.skAdmins = newAdmins
      this.getAdminData()
    },
    search_admin() {
      this.searchAdmin()
    }
  },
  methods: {
    ...mapActions(['account/admins', 'admin/getStatus']),
    searchAdmin() {
      const params = {
        show_count_cases: true
      }
      if (this.search_admin) params.name = this.search_admin
      if (this.currentGroup) params.group_id = this.currentGroup
      this['account/admins']({
        account_id: this.$route.params.account_id,
        params,
        callback: (res) => {
          if (res.error) return this.$message.error(res.error)
        }
      })
    },
    loadGroupAdmins(groupId) {
      const { account_id: accountId } = this.$route.params
      this.currentGroup = groupId || null
      const params = {
        group_id: groupId
      }
      this['account/admins']({
        account_id: accountId,
        params,
        callback: (res) => {
          if (res.error) {
            return this.$message.warning(
              'No logramos cargar la información, por favor verifica tu conexión a internet'
            )
          }
          this.getAdminsStatus()
          this.skAdmins = this.admins
        }
      })
    },
    updateAdminTimes() {
      this.skAdmins.forEach((admin) => {
        if (!admin.timeObserver) return
        admin.statusTime = this.adminCasesTime(admin.timeObserver.getTimes())
      })
    },
    adminCasesTime(statusTime) {
      const threeMin = 60 * 3
      const fifteenMin = 60 * 15
      return statusTime.map(Number).reduce(
        (acc, curr) => {
          let duration = ''
          if (isNaN(curr)) return acc
          if (curr <= threeMin) duration = 'lessThree'
          else if (curr > threeMin && curr <= fifteenMin) duration = 'overThree'
          else duration = 'overFiveTen'
          acc[duration]++
          return acc
        },
        { lessThree: 0, overThree: 0, overFiveTen: 0 }
      )
    },
    catchAdminCases(admins = []) {
      this.skAdmins = this.admins.map((admin) => {
        const currentAdmin = admins[admin.admin_id] || {}
        const { open = { durations: [] }, onHold = { duration: [] } } =
          currentAdmin
        if (!admin.timeObserver) admin.timeObserver = new TimeChild(timeObserver)
        admin.timeObserver.setDates([
          ...(open.durations || [])
        ])
        admin.timeObserver.update()
        admin.statusTime = this.adminCasesTime(admin.timeObserver.getTimes())
        admin.statusCases = { open, onHold }
        return admin
      })
    },
    updateAdmin({ admin, statuses }) {
      const { open = {}, onHold = {} } = statuses
      const currentAdmin = this.skAdmins.find((a) => a.admin_id === admin)
      currentAdmin.statusTime = this.adminCasesTime(statuses)
      currentAdmin.statusCases = { open, onHold }
    },
    loadSocket() {
      if (!this.caseSocket.isConnected) return
      this.caseSocket.emit('resetFilters')
      this.caseSocket.on('adminCasesStats', this.catchAdminCases)
      this.caseSocket.on('adminUpdate', this.updateAdmin)
      this.caseSocket.on('reloadFilters', this.getAdminData)
    },
    getAdminData() {
      const admins = this.admins.map((a) => a.admin_id)
      this.caseSocket.emit('adminCasesStats', { admins, account: this.account })
    },
    initSocket() {
      setTimeout(() => {
        if (!this.caseSocket.isConnected) return this.initSocket()
        this.loadSocket()
        // this.getAdminData()
      }, 1000)
    },
    getAdminsStatus() {
      this['admin/getStatus']({
        params: {
          admin_id: JSON.stringify(this.admins.map((a) => a.admin_id)),
          account_id: this.$route.params.account_id
        },
        callback: (res) => {
          if (res.error) return this.$message.error(res.error)
          this.admins_status = res.resource.slice()
        }
      })
    },
    setFilter(name, event) {
      const data = {
        name,
        value: event.value
      }
      this.caseSocket.emit('setFilter', data)
    }
  },
  mounted() {
    this.account = this.$route.params.account_id
    this.loadGroupAdmins()
    EventBus.$once('updateAdmins', () => this.getAdminData())
    this.initSocket()
    EventBus.$on('time-update', () => this.updateAdminTimes())
  },
  unmounted() {
    EventBus.$off('updateAdmins')
    EventBus.$off('time-update')
    this.caseSocket.off('adminCasesStats')
  }
}
</script>

<style scoped></style>
